<lib-dialog
  [title]="
    (customerToEdit?.id
      ? 'customer-form-dialog.text.edit_customer'
      : 'customer-form-dialog.text.create_customer'
    ) | translate
  "
  [subtitle]="generateSubtitle()"
  [isLoading]="isLoading"
  [hideCloseButtonIcon]="true"
>
  <div body>
    <lib-customer-form
      [businessObject]="businessObject"
      [displayFullContactData]="displayFullContactData"
      [isAbleToEditLoyalPoint]="isAbleToEditLoyalPoint()"
      [isAbleToEditCommunicationWay]="false"
      [formControl]="customerFormControl"
    ></lib-customer-form>
  </div>

  <ng-container action>
    <button mat-dialog-close mat-stroked-button>
      {{ 'customer-form-dialog.button.cancel' | translate }}
    </button>

    <button
      (click)="submit()"
      [disabled]="!isAbleToSubmit()"
      color="primary"
      mat-flat-button
    >
      {{ 'customer-form-dialog.button.submit' | translate }}
    </button>
  </ng-container>
</lib-dialog>
